import React from 'react';

export default () => (
  <a href="https://www.simpolium.com">
    <img src="/logo.png" height="25" alt="Simpolium" style={{marginBottom: 20}} />
  </a>)